import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { TreoDateRangeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatDividerModule } from '@angular/material/divider';
import { TreoNavigationModule } from 'tsui/@treo';
import { NgApexchartsModule } from 'ng-apexcharts';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoMessageModule } from 'tsui/@treo';
import { TreoCardModule } from 'tsui/@treo';
import { MatSortModule } from '@angular/material/sort';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { insightsRoutes } from './insights.routing';
import { ProjectInsightsComponent } from './insights.component';
import { ProjectInsightsMarketComponent } from './market/market.component';
import { ProjectInsightsAnalyticsComponent } from './analytics/analytics.component';
import { ProjectInsightsRecordsComponent } from './records/records.component';
import { ProjectInsightsCompsComponent } from './comps/comps.component';
import { ProjectInsightsSidebarComponent } from './sidebar/sidebar.component';
import { ProjectsListFilterComponent } from './filter/projects-list-filter.component';
import { ProjectInsightsAddCompsetComponent } from './add-compset/add-compset.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { CompsEditComponent } from './comps/comps-edit/comps-edit.component';
import {
  TSIconModule,
  TsBadgeModule,
  TsButtonModule,
  TsFilterModule,
  TsInputComponent,
  TsOverlayModule,
  TsMenuComponent,
} from 'tsui';
import { DirectivesModule } from '@shared/directives/directives.module';

@NgModule({
  declarations: [
    ProjectInsightsComponent,
    ProjectInsightsMarketComponent,
    ProjectInsightsRecordsComponent,
    ProjectInsightsCompsComponent,
    ProjectInsightsSidebarComponent,
    ProjectsListFilterComponent,
    ProjectInsightsAddCompsetComponent,
    ProjectInsightsAnalyticsComponent,
    CompsEditComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(insightsRoutes),
    ScrollingModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatMenuModule,
    MatMomentDateModule,
    MatRadioModule,
    NgApexchartsModule,
    MatSelectModule,
    TreoNavigationModule,
    TreoAutogrowModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    TreoFindByKeyPipeModule,
    TreoMessageModule,
    TreoCardModule,
    NgxMapboxGLModule,
    MatTableModule,
    MatSortModule,
    MatDividerModule,
    MatSidenavModule,
    MatTooltipModule,
    MatChipsModule,
    MatPaginatorModule,
    TreoDateRangeModule,
    SharedModule,
    ColumnSelectorModule,
    TsFilterModule,
    TsOverlayModule,
    TsButtonModule,
    TsBadgeModule,
    TsInputComponent,
    TsMenuComponent,
    TSIconModule,
    DirectivesModule,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class ProjectInsightsModule {}
